import { render } from "./CoursesCategories.vue?vue&type=template&id=03f1228a"
import script from "./CoursesCategories.vue?vue&type=script&lang=js"
export * from "./CoursesCategories.vue?vue&type=script&lang=js"

import "./CoursesCategories.vue?vue&type=style&index=0&id=03f1228a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__